<template>
  <div class="flex mb-2 space-x-2 items-center h-[120px]">
    <div class="flex flex-1 flex-col gap-1">
      <label class="text-surface-500 text-sm" for="username">Name SK</label>
      <InputText id="name_sk" v-model="state.name_sk" size="small"/>
    </div>
    <div class="flex flex-1 flex-col gap-1">
      <label class="text-surface-500 text-sm" for="username">Name EN</label>
      <InputText id="name_en" v-model="state.name_en" size="small"/>
    </div>
    <div class="flex flex-1 flex-col gap-1">
      <label class="text-surface-500 text-sm" for="username">Name DE</label>
      <InputText id="name_de" v-model="state.name_de" size="small"/>
    </div>
    <div class="flex flex-1 flex-col gap-1">
      <label class="text-surface-500 text-sm" for="username">Name CZ</label>
      <InputText id="name_cz" v-model="state.name_cz" size="small"/>
    </div>
    <div class="w-[230px]">
      <img :src="`/images/burger-parts/${state.src}`" class="w-auto flex h-full max-w-full mx-auto">
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
})

const state = defineModel()

</script>